"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUpLogger = exports.logError = exports.logDebugging = void 0;

var _this = void 0;

var debugEnabled = false;

var onErrorCallbackFn = function onErrorCallbackFn() {};

var prefix = ['%ctab-cmp', 'background: #7c7c7c; color: #fff; border-radius: 2px; padding: 2px 6px'];

var setUpLogger = function setUpLogger(_ref) {
  var debug = _ref.debug,
      onErrorCallback = _ref.onErrorCallback;
  debugEnabled = debug;

  if (typeof onErrorCallback === 'function') {
    onErrorCallbackFn = onErrorCallback;
  }
};

exports.setUpLogger = setUpLogger;

var logDebugging = function logDebugging() {
  if (debugEnabled) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    } // eslint-disable-next-line no-console


    console.log.apply(_this, [].concat(prefix, args));
  }
};

exports.logDebugging = logDebugging;

var logError = function logError(err) {
  var _console; // eslint-disable-next-line no-console


  (_console = console).error.apply(_console, prefix.concat([err]));

  onErrorCallbackFn(err);
};

exports.logError = logError;